/**
 * Valida que un texto contenga sólo números
 * @param text
 * @returns
 */
export const isNumericText = (text: string): boolean => {
  const regex = /^[0-9]*$/;
  return regex.test(text);
};

/**
 * Devuelve el texto con la primera letra en mayúscula, dejando el resto igual.
 * Pensado para rotular datos de catálogo que se guardan en minúscula
 * (p.ej. los nombres de `campus_period_type`: "semestre" -> "Semestre").
 * @param text
 * @returns
 */
export const capitalizeFirst = (text: string): string => {
  if (!text) {
    return text;
  }
  return text.charAt(0).toUpperCase() + text.slice(1);
};
